/* istanbul ignore file */
import { boolean as codecBoolean } from 'purify-ts/Codec';
import { utils as coreUtils } from '@codegrade/api-core';
import { parsers } from '@codegrade/utils';
const SubmissionPermissionsParser = 
/* #__PURE__ */ parsers.object([
    ['edit', codecBoolean],
    ['view', codecBoolean],
    ['submit', codecBoolean],
    ['create', codecBoolean],
]);
export class SubmissionPermissions extends /* #__PURE__ */ coreUtils.AssigningBase {
    static decode(input) {
        return SubmissionPermissionsParser.decode(input).map(res => new SubmissionPermissions(res));
    }
    static unsafeDecode(input) {
        return SubmissionPermissions.decode(input).unsafeCoerce();
    }
    static encode(data) {
        return SubmissionPermissionsParser.encode(data);
    }
    static schema() {
        return SubmissionPermissionsParser.schema();
    }
}
